var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-p-3 tw-mt-2",attrs:{"theme":"danger"}},[_vm._v(" These dates are currently unavailable to book. Please contact your administrator to activate a calendar for this period. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }